module.exports = __webpack_public_path__ + "media/about/shay-9f195725.jpg";